import React from 'react';
import {
    Container,
    Content,
    Floating
} from './styled';


export function Card({ company, onClick }) {
    const {
        avatar,
        nome,
        descricao
    } = company

    return (
        <Container onClick={onClick}>
            <Floating className='flt-image'>
                <div>
                    <img
                        src={avatar}
                        alt={`logo-${nome}`}
                    />
                </div>
            </Floating>
            <Content>
                <span>
                    {nome}
                </span>
                <span>
                    {descricao}
                </span>
            </Content>
        </Container>
    )
}